import { client as geocoderClient } from '@/modules/api/geocoder/client.gen';
import { OpenAPI as OpenAPIRouting } from '@/modules/api-routing';

geocoderClient.setConfig({ baseUrl: '/api/pelias' });
OpenAPIRouting.BASE = import.meta.env.VITE_ROUTING_URL || '';
